import { useQuery } from '@tanstack/react-query';

import loyaltyFlow from '../../common/flow/loyaltyFlow';
import { pointsQueryKeys } from '../../member/pointshop/pointsQueryKeys';
import { useIsEligibleForNewBonusSystem } from './useIsEligibleForNewBonusSystem';

export const bonusLevelTimelineQueryOptions = ({
    beId,
    isAuthenticated,
    enabled,
}: {
    beId?: string;
    isAuthenticated: boolean;
    enabled: boolean;
}) => ({
    queryKey: pointsQueryKeys.bonusLevelTimeline(beId, isAuthenticated),
    queryFn: loyaltyFlow.getBonusLevelTimeline,
    staleTime: 1000 * 60 * 60,
    enabled,
    retry: false,
});

export const useBonusLevelTimelineQuery = ({ enabled }: { enabled?: boolean } = {}) => {
    const { beId, isAuthenticated, isEligibleForNewBonusSystem } = useIsEligibleForNewBonusSystem();

    return useQuery(
        bonusLevelTimelineQueryOptions({
            beId,
            isAuthenticated,
            enabled: enabled ?? isEligibleForNewBonusSystem,
        }),
    );
};
